<template>
	<div data-component="embedded-presentation">
		<validation-observer
			data-element="form"
			tag="form"
			ref="form"
			@submit.prevent="submit"
			v-if="formLoaded"
		>
			<input-field
				name="Title"
				type="text"
				rules="required"
				v-model="activity.title"
			/>
			<upload
				fileType="pptx"
				:form.sync="form"
				:media="activity.media"
				@deleteMedia="deleteMedia"
				:isWaiting="isWaiting"
			/>
			<actions
				:actions="getActions"
				@actionClick="onActionClick"
				:isWaiting="isWaiting"
			/>
		</validation-observer>
	</div>
</template>

<script>

	import InputField        from '@/components/forms/InputField';
	import Upload            from '@/components/uploads/Upload';
	import Actions           from '@/components/ui/Actions';
	import activityDefaults  from '@/mixins/activityDefaults';

	export default {
		components: {
			InputField,
			Upload,
			Actions
		},
		mixins: [activityDefaults],
		data: () => ({
			form: undefined
		}),
		computed: {},
		methods: {}
	};

</script>

<style lang="scss" scoped>

	[data-component='quiz'] {}

</style>
